// @flow
import React, { Component } from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { Button, Dimmer, Header, Icon, Loader, Menu, Responsive, Sidebar } from 'semantic-ui-react';
import AnalyticsNotificationStack from '../containers/AnalyticsNotificationStack';
import uuid from 'uuid/v4';
import { parse, stringify } from 'query-string';
import { Forbidden } from 'http-errors';
import VersionInfo from './atoms/VersionInfo';
const pkg = require('../package.json');
import { redirectToLogin } from '../modules/utils';
import TimeoutModal from '../components/molecules/TimeoutModal';

import HeaderMenu from '../containers/HeaderMenuContainer';
import Dashboard from '../containers/DashboardContainer';
import Report from '../containers/ReportContainer';
import Grid from '../containers/GridContainer';
// import Subscriptions from './pages/Subscriptions';
// import Topics from './pages/Topics';
import Alert from './pages/Alert';
import { PLATFORM_URL, REPORTING_API } from '../modules/consts';

export default class App extends Component<
    { user: User, getLogin: () => Promise<User> },
    {
        forbidden: boolean,
        loggingIn: boolean,
        loggedIn: boolean,
        paddingRight: number,
        visible: boolean
    }
> {
    constructor() {
        super();
        this.state = {
            forbidden: false,
            loggingIn: true,
            loggedIn: false,
            paddingRight: window.innerWidth > Responsive.onlyTablet.maxWidth ? 260 : 0,
            visible: false
        };
    }
    componentDidMount() {
        this.props.getLogin().then(
            user => {
                this.setState({ loggedIn: true, loggingIn: false });
            },
            err => {
                if (err instanceof Forbidden) {
                    this.setState({ forbidden: true, loggingIn: false });
                } else {
                    redirectToLogin();
                }
            }
        );
    }
    handleShowClick = () => this.setState({ visible: true });
    handleSidebarHide = () => this.setState({ visible: false });
    render() {
        const HeaderRoute = properties => (
            <Route path="*" render={props => <HeaderMenu {...props} {...properties} />} />
        );
        const {
            desktopVisible,
            forbidden,
            loggedIn,
            loggingIn,
            paddingRight,
            visible
        } = this.state;
        if (loggingIn) {
            return (
                <div>
                    <Dimmer active>
                        <Header as="h2" icon inverted>
                            <Loader>Logging In...</Loader>
                        </Header>
                    </Dimmer>
                </div>
            );
        }

        if (loggedIn) {
            return (
                <BrowserRouter basename="/">
                    <Sidebar.Pushable>
                        <Responsive as={React.Fragment} {...Responsive.onlyComputer}>
                            <HeaderRoute visible />
                        </Responsive>
                        <Responsive
                            as={React.Fragment}
                            minWidth={Responsive.onlyMobile.minWidth}
                            maxWidth={Responsive.onlyTablet.maxWidth}
                            onUpdate={() =>
                                this.setState(prevState => ({
                                    paddingRight:
                                        window.innerWidth > Responsive.onlyTablet.maxWidth ? 260 : 0
                                }))
                            }
                        >
                            <HeaderRoute onHide={this.handleSidebarHide} visible={visible} />
                        </Responsive>
                        <Sidebar.Pusher dimmed={visible} style={{ paddingRight }}>
                            <Responsive
                                as={React.Fragment}
                                minWidth={Responsive.onlyMobile.minWidth}
                                maxWidth={Responsive.onlyTablet.maxWidth}
                            >
                                <Menu icon>
                                    <Menu.Item onClick={this.handleShowClick}>
                                        <Icon name="bars" />
                                    </Menu.Item>
                                </Menu>
                            </Responsive>
                            <div
                                className="flex flex-1"
                                style={{
                                    flexDirection: 'column',
                                    minHeight: '100vh',
                                    padding: `1rem 1rem 1rem 1rem`
                                }}
                            >
                                <div className="flex-1" style={{ maxWidth: '100%' }}>
                                    <Route
                                        exact
                                        path="/"
                                        render={props => (
                                            <Redirect
                                                to={{
                                                    pathname: '/dashboards',
                                                    search: props.location.search
                                                }}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/dashboards/:dashboardId?"
                                        render={props => (
                                            <Dashboard
                                                clientId={parse(props.location.search).clientId}
                                                {...props}
                                            />
                                        )}
                                    />
                                    <Route path="/reports/:reportId?" component={Report} />
                                    {/*<Route path="/subscriptions" component={Subscriptions} />*/}
                                    {/*<Route path="/topics" component={Topics} />*/}
                                    <Route
                                        path="/alerts/:alertId?"
                                        render={props => (
                                            <Alert
                                                clientId={parse(props.location.search).clientId}
                                                {...props}
                                            />
                                        )}
                                    />
                                    <Route path="/grids/:gridId?/:filterId?" component={Grid} />
                                </div>
                                <footer style={{ paddingTop: '1rem' }}>
                                    <VersionInfo fromYear={2017} version={pkg.version} />
                                </footer>
                                <AnalyticsNotificationStack />
                            </div>
                        </Sidebar.Pusher>
                    </Sidebar.Pushable>
                </BrowserRouter>
            );
        }

        if (forbidden) {
            return (
                <div>
                    <Dimmer active>
                        <Header as="h2" style={{ width: '100%' }} icon inverted>
                            <Icon name="warning" />
                            {`You don't have permission to run this app.`}
                            <Header.Subheader>Ask your administrator for access.</Header.Subheader>
                        </Header>
                        <Button
                            as="a"
                            color="blue"
                            content="Back to the Platform"
                            href={`${PLATFORM_URL}`}
                            icon="undo"
                        />
                    </Dimmer>
                </div>
            );
        }

        return (
            <div>
                <Dimmer active>
                    <Header as="h2" style={{ width: '100%' }} icon inverted>
                        <Icon name="warning" />
                        Login Error
                    </Header>
                    <a href={PLATFORM_URL}>
                        <Button
                            icon="undo"
                            color="blue"
                            content="Re-Launch from The Platform"
                            size="massive"
                        />
                    </a>
                </Dimmer>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/App.jsx